import { cartNumber } from './cartItem';

export const cashbackCents = (value: unknown): number => Math.max(0, Math.round(cartNumber(value) * 100));

/** The reviewed selection is an upper bound; a larger cart never spends more cashback. */
export function appliedCashback(requested: number, subtotal: unknown, delivery: unknown, coupon: unknown, available?: number | null): number {
  const orderLimit = Math.max(0, cashbackCents(subtotal) + cashbackCents(delivery) - cashbackCents(coupon));
  const availableLimit = available == null ? Number.MAX_SAFE_INTEGER : cashbackCents(available);
  return Math.min(cashbackCents(requested), orderLimit, availableLimit) / 100;
}
